const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  role: state => state.user.userInfo.role
}

export default getters
